import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Surveytooltip from "./SurveyTooltip";
import SurveyRequired from "./SurveyRequired";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class SurveySingleFileUpload extends Component {
  state = {
    files: [], // array to match backend List<IFormFile>
  };

  componentDidMount() {
    const { data, response } = this.props;
    const questionId = data.questionId;

    const matchedResponse = response?.SurveyResponses?.find(
      (r) => r.questionId === questionId
    );

    if (matchedResponse?.fileAttachments?.length > 0) {
      const attachment = matchedResponse.fileAttachments[0];

      const file = new File(
        [
          Uint8Array.from(
            atob(attachment.DocumentBody),
            (c) => c.charCodeAt(0)
          ),
        ],
        attachment.FileName,
        {
          type: attachment.ContentType || "application/octet-stream",
          lastModified: Date.now(),
        }
      );

      this.setState({ files: [file] });

      this.props.setUpdateFile(
        { "required": data.isMandatoryQuestion, "data": [file] },
        this.props.uid,
        data.questionId
      );
    }
  }

  handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const files = [file];

    this.setState({ files });

    this.props.setUpdateFile(
      {
        "required": this.props.data.isMandatoryQuestion,
        "data": files,
      },
      this.props.uid,
      this.props.data.questionId
    );
  };

  handleRemoveFile = () => {
    this.setState({ files: [] });

    this.props.setUpdateFile(
      {
        required: this.props.data.isMandatoryQuestion,
        data: [],
      },
      this.props.uid,
      this.props.data.questionId
    );
  };

  render() {
    const { data } = this.props;
    const { files } = this.state;

    const file = files[0];
    const displayFileName = file?.name || null;

    return (
      <Form.Group>
        <div className="surveyquestions" id={this.props.data.relatedToQuestionId ? this.props.data.relatedToQuestionId : ""}>
          <p>
            {data.question}
            {data.isMandatoryQuestion && <SurveyRequired />}
            {data.questionTooltip && (
              <Surveytooltip text={data.questionTooltip} />
            )}
          </p>

          {/* File name / No file chosen */}
          <div className="mt-1 d-flex align-items-center">
            {displayFileName ? (
              <>
                <span>🗎 {displayFileName}</span>
                <span style={{ cursor: "pointer", color: "black" }}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={this.handleRemoveFile}
                    className="ml-2"
                  />
                </span>
              </>
            ) : (
              <span className="text-muted">Ingen fil er valgt</span>
            )}
          </div>

          {/* Choose file button */}
          <label
            className={window.globalConfig.CustomerName === "Rettssenteret"?"generalbtn-Rettssenteret pl-3 pr-3 pt-2 pb-2 ml-3 survey-btn":"generalbtn pl-3 pr-3 pt-2 pb-2 mt-2 survey-btn"}
          >
            Choose file
            <input type="file" hidden onChange={this.handleChange} />
          </label>
        </div>
      </Form.Group>
    );
  }
}
